import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Dialog from '@shared/ui/molecules/Dialog';
import DialogHeader from '@shared/dialogs/DialogHeader';
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { useTranslation } from 'react-i18next';
import { closeDialog } from '@shared/store/dialog.duck';
import { loadAccountInfo } from '@features/settings/store/payments.duck';
import { changeSubscriptionPlan } from '@shared/ui/organisms/stripe/stripeService';
import { successNotification, failureNotification } from '@shared/store/notification.duck';
import { AccountType } from '@shared/models/company.models';
import { TrackJS } from 'trackjs';

export function ChangePlanConfirmDialog(props: Props) {
  const { tier } = props.payload;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const close = () => dispatch(closeDialog());

  const confirm = async () => {
    setLoading(true);
    try {
      await changeSubscriptionPlan(tier);
      dispatch(loadAccountInfo());
      dispatch(successNotification(t('payments.plan-changed')));
      dispatch(closeDialog());
    } catch (e: any) {
      console.error(e);
      TrackJS?.track(e);
      dispatch(failureNotification(t('payments.plan-change-failed')));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog isOpen={true} onClose={close} showLogo={true}>
      <DialogHeader title={'payments.confirm-plan-change-title'} />
      {loading ?
        <Center><LoadingSpinner hideBorder={true} hideText={true} /></Center> :
        <>
          <BodyRegular style={{ marginBottom: 16 }}>{t('payments.confirm-plan-change')}</BodyRegular>
          <PrimaryButton click={confirm}
                         style={{ marginBottom: 16 }}
                         text={'payments.confirm-plan-change-button'}
                         fullWidth={true} />
          <OutlineButton click={close} text={'button.cancel'} fullWidth={true} />
        </>}
    </Dialog>
  );
}

interface Props {
  payload: {
    tier: AccountType;
  };
}
